/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Sidebar.module.css';

export default function LinkListSection({
  items,
  emptyLabel,
  renderAction,
}) {
  return (
    <ul style={{ paddingLeft: 0, listStyle: 'none', margin: 0 }}>
      {items.length === 0 && (
        <li className={styles.linkSectionEmpty}>{emptyLabel}</li>
      )}
      {items.map((item) => {
        const action = renderAction ? renderAction(item) : null;
        const ActionIcon = action?.Icon;
        return (
          <li key={item.id} className={styles.linkItem}>
            <Link to={item.url} className={styles.linkItemLink} title={item.label}>
              {'— '}
              {item.label}
            </Link>
            {action && (
              <button
                type="button"
                className={styles.linkItemAction}
                aria-label={action.label}
                title={action.label}
                onClick={() => action.onClick(item)}
              >
                <ActionIcon
                  size={12}
                  fill={action.active ? 'var(--color-accent)' : 'none'}
                  color={action.active ? 'var(--color-accent)' : undefined}
                />
              </button>
            )}
          </li>
        );
      })}
    </ul>
  );
}
